import React, { FC } from 'react';
import { getDateAndMonth } from 'utils/date';
import styles from './OrderItem.module.scss';
import { BeneficiariesTabBtn } from 'ui/BeneficiariesTabBtn';
import { InfoEmployedItem } from 'components/InfoEmployedItem';
import { FormatAmount } from 'ui/FormatAmount';
import classNames from 'classnames';
import { ReactComponent as Checkbox } from './img/checkbox.svg';

interface OrderItemTypes {
  order: any;
  withCheckbox?: boolean;
  selected: boolean;
  toggleSelect: (id: string) => void;
}

export const OrderItem: FC<OrderItemTypes> = ({
  order,
  withCheckbox = false,
  selected,
  toggleSelect,
}) => {
  // console.log('order', order);
  return (
    <div
      className={classNames(
        styles.root,
        withCheckbox && styles.withCheckbox,
        selected && styles.selected,
      )}>
      {withCheckbox && (
        <div
          className={classNames(styles.root_checkbox, selected && styles.with_checkbox)}
          onClick={(e) => {
            e.preventDefault();
            toggleSelect(order.id);
          }}>
          {selected ? (
            <div className={styles.checkbox_active}>
              <Checkbox />
            </div>
          ) : (
            <div className={styles.checkbox}></div>
          )}
        </div>
      )}
      <p className={styles.root_item__standart}>{getDateAndMonth(order?.created_at)}</p>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p className={styles.root_item__standart}>{order.customer?.jur_name}</p>
        <div style={{ display: 'flex', columnGap: '10px' }}>
          <p className={styles.root_item__for_ndfl}>ИНН {order.customer?.inn}</p>
          <p className={styles.root_item__for_ndfl}>КПП {order.customer?.kpp}</p>
        </div>
      </div>
      <div
        className={styles.root_item}
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '8px 0',
          minWidth: 0,
          overflow: 'hidden',
        }}>
        {order.worker ? (
          <InfoEmployedItem
            fns_status={order.worker?.fns_status}
            orders
            inn={order.worker?.inn}
            fio={
              !order.worker?.surname
                ? order.worker?.name
                : order.worker?.patronymic
                ? `${order.worker?.surname} ${order.worker?.name} ${order.worker?.patronymic}`
                : `${order.worker?.surname} ${order.worker?.name}`
            }
            workerAppStatus={order.worker?.app_status}
            isDelete={order.worker?.is_deleted}
          />
        ) : (
          <p style={{ padding: '12px 20px' }} className={styles.root_item__standart}>
            {' '}
            -{' '}
          </p>
        )}
      </div>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p className={styles.root_item__standart}>{order.order_type}</p>
        <p className={styles.root_item__for_ndfl}>{order.description}</p>
      </div>
      <FormatAmount amount={order.amount} />
      <FormatAmount amount={order.commission_amount} />
      <div className={styles.root_item} style={{ display: 'inline-flex' }}>
        <BeneficiariesTabBtn
          title={order.status?.text}
          color={order.status?.color_text}
          bg={order.status?.color_bg}
        />
      </div>
    </div>
  );
};
